import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { MainService } from './core/main.service';
import { AppConfig } from '../environments/environment';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'
import {Title} from "@angular/platform-browser";
import {Subscription, interval, timer} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public debug:boolean = false;

  private datasServer:any;
  public datasName:any;
  public base:string;
  public datas:any;

  public loop:boolean;

  private activityDelay:number = 5*60*1000; //ms
  private activitySubscription:Subscription;

  public lang:string;

  public isVP:any;
  private videoFolders:any;
  public selected:number;

  public grid6:boolean;

  public current:string = 'loading';

  public debugTxt:string = '';

  public currentVideo:string;
  private videoSubscription:Subscription;
  public tab:number = 1;
  public videosTab1:Array<any>;
  public videosTab2:Array<any>;
  public videosTab:Array<any>;

  private espaces:Array<any> = [
    {
      name: 'Végétale',
      color: '#fbab18'
    },
    {
      name: 'Animale',
      color: '#ee4991'
    },
    {
      name: 'Humaine',
      color: '#00aab0'
    },
    {
      name: 'Artificielle',
      color: '#ef4023'
    }
  ];
  public espace;

  @ViewChild('video', {static: false}) videoTag : ElementRef;
  videoProgress:number = 0;

  constructor(
    private service: MainService,
    private sanitizer:DomSanitizer,
    private titleService: Title
  ) {
    this.log('constructor');
  }

  ngOnInit(){
    this.log('ngOnInit');
    this.base = AppConfig.datasServer;

    this.log('AppConfig', AppConfig, "*");

    this.datasName = this.findGetParameter('datas');
    this.datasName = 'videosmore'; // force app !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    this.log("this.datasName", this.datasName);

    this.checkIfVP();
    this.loadDatas();

    window.addEventListener('idal-player-event', (e) => {
      // this.log();
      if (e['detail'].type == 'folder-enter') {
        if (e['detail'].folder.number == 900){
          this.current = 'splash';
          this.selected = -1;
          // this.ngZone.run(() => {});
        }
      }
    });

    window.addEventListener('idal-contact-event', (e) => {
      // this.log();
      let info = e['detail'];
      console.log("Input contact name: " + info.name);
      this.selected = info.values.findIndex(elt => elt);
      this.playVideo({base: this.datas.videos[this.selected].video, inc: this.selected}, false);
    });


    this.log(location.href, location.href.match(/www.apps/g));

    // this.log(window['IDAL']);
  }

  checkIfVP(){
    // Detect Wave System player in VP330 ou VP320
    this.isVP = navigator.userAgent.search("WSPlayer") != -1;
  }

  loadDatas(){
    this.current = 'loading';
    this.service.loadDatas(this.datasName).subscribe((datas => {
      this.log("datas.name", datas.name);
      this.datas = datas;
      console.log('this.datas', this.datas); 
      this.espace = this.espaces.find((espace) => espace.name == this.datas.espace);
      this.titleService.setTitle( this.datas.name );

      this.lang = 'fr';

      this.videosTab1 = [];
      while (this.datas['video'+(this.videosTab1.length+1)]){
        this.videosTab1.push(this.datas['video'+(this.videosTab1.length+1)]);
      }
      this.videosTab1 = this.videosTab1.map((elt, i) => ({...elt, pos: i}));
      
      this.videosTab2 = [];
      while (this.datas['videoplus'+(this.videosTab2.length+1)]){
        this.videosTab2.push(this.datas['videoplus'+(this.videosTab2.length+1)]);
      }
      this.videosTab2 = this.videosTab2.map((elt, i) => ({...elt, pos: i}));

      this.videosTab = this.videosTab1;
      this.grid6 = (this.videosTab.length > 2);

      this.log('this.videosTab', this.videosTab);
      this.log('this.isVP()', this.isVP);

      this.service.loadVideoFolders(this.datasName).subscribe((datas) => {
        this.videoFolders = datas;
        this.start();
      });
    }));
  }

  start(){
    this.openHome();
  }

  openHome(){
    this.selected = -1;
    this.current = 'splash';
  }

  findGetParameter(parameterName:string) {
      let result = null,
          tmp = [];
      let items = location.search.substr(1).split("&");
      for (let index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
  }
  onLang(lang:string):void
  {
    this.lang = lang;
  }
  onSplashClick() {
    if (AppConfig.name == 'web'){
      if (!document.fullscreenElement){ document.documentElement.requestFullscreen(); }
    }
  }
  playVideo(folderBaseAndInc, loop){
    console.log('playVideo');
    this.current = 'video';
    let folder:string = folderBaseAndInc.base;

    let folderSplit = folder.split('*');
    if (folderSplit.length > 1){
      let num = parseInt(folderSplit.shift());
      if (folderBaseAndInc.inc != null){
        num += folderBaseAndInc.inc;
      }
      folder = this.toStringLen(num, 3) + folderSplit.join('');
    }

    if (this.isVP){
      this.playVideoExt(folder);
    } else {
      this.playVideoWeb(folder, loop);
    }
    this.log('current', this.current);
  }
  playVideoWeb(videoFolder:string, loop:boolean){
    this.loop = loop;

    let sel = this.videoFolders.filter((elt) => elt.folder == videoFolder);
    if (sel.length){
      this.currentVideo = videoFolder+'/'+sel[0].video;
      this.videoSubscription = interval(1000).subscribe(() => {
        this.videoUpdate();
      });
    }

  }
  playVideoExt(videoFolder:string){
    this.currentVideo = videoFolder;

    let folderSplit = videoFolder.split('/');
    let folderNum = parseInt(folderSplit.shift());
    // let toPlay = this.videoFolders.filter((videoFolder) => video == videoFolder.video);
    // let folder = parseInt(toPlay[0].folder);

    this.log(window['IDAL'].getControlInterfaces);
    window['IDAL'].getControlInterfaces().then((ifaces) => {
      this.log('got ifaces');
      this.log("load", folderNum);

      ifaces.player.stop().then(() => {
        ifaces.player.playFolder(folderNum).then((ret) => {
          this.log('playing');
        }).catch(function(error) {
          this.log("control interface error");
          // Faire quelque chose d'utile...
        });
      });
    });

    // this.log("click", window['IDAL'].getControlInterfaces());
    // window['IDAL'].getControlInterfaces().then(function(ifaces) {
    //         // L'object ifaces contient toutes les interfaces de contrôle:
    //         //      - ifaces.player
    //         //      - ifaces.serial
    //         //      - ifaces.logger
    //         //      - ifaces.printer
    //         //      - ifaces.contact
    //
    //         // Il est maintenant par example possible de contrôler la lecture vidéo:
    //         ifaces.player.getAllFolders().then(function(folders) {
    //             // Faire quelque chose d'utile...
    //             this.log("Folders received: " + JSON.stringify(folders));
    //         }).catch(function(error) {
    //           this.log("ifaces.player.getAllFolders error");
    //           // Faire quelque chose d'utile...
    //         });
    // }).catch(function(error) {
    //   this.log("control interface error");
    //   // Faire quelque chose d'utile...
    // });




    // this.videoSubscription = interval(1000).subscribe(() => {
    //   this.videoUpdate();
    // });
  }

  getPoster(videoSrc){
    return videoSrc.replace('.mp4', '.jpg');
  }
  videoUpdate(){
    if (this.videoTag && this.videoTag.nativeElement){
      this.videoProgress = Math.round(100 * this.videoTag.nativeElement.currentTime / this.videoTag.nativeElement.duration);
    } else {
      this.videoProgress = 0;
    }
  }
  onVideoEnded(e){
    if (this.videoSubscription){
      this.videoSubscription.unsubscribe();
      delete this.videoSubscription;
    }
    this.videoProgress = 100;

    this.openHome();
    // this.current = 'splash';
  }
  onVideoClick(){
    // this.current = 'splash';
  }
  onClick(){
    if (this.activitySubscription){
      this.activitySubscription.unsubscribe();
      delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      this.log("activitySubscription");
      this.current = 'splash';
    });
  }

  bgImage(fileName:string):any
  {
    return this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+fileName +')');
  }

  log(...txts:any){
    if (false || this.isVP){
      this.debugTxt += txts.join(', ');
      this.debugTxt += '<br>';
      this.debugTxt += '------';
      this.debugTxt += '<br>';
    } else {
      console.log(...txts);
    }
  }

  toStringLen(num:number, len:number):string
  {
    let ret = ''+num;
    while(ret.length < len){
      ret = '0'+ret;
    }
    return ret;
  }


  onPlay(video:any):void
  {
    if (this.tab == 1 && video.pos == 0){ // see more
      this.videosTab = this.videosTab2;
      this.tab = 2;
    } else if (this.tab == 2 && video.pos == 0){ // go back
      this.videosTab = this.videosTab1;
      this.tab = 1;
    } else {
      this.playVideo({base: video.video, inc: 0}, false);
    }
  }

  onKey($event):void
  {
    console.log("keyup !");
  }


}
